import { t as msg } from "../lib/i18n";
import { useState } from "react";
import { api } from "../lib/api";
import { SubmissionCheck } from "../components/SubmissionCheck";
import { useVerifiedSubmission } from "../lib/useVerifiedSubmission";

export function Support({ accountId }: { accountId?: string }) {
  const [email, setEmail] = useState(""),
    [text, setText] = useState(""),
    [topic, setTopic] = useState(new URLSearchParams(location.search).get("topic") === "privacy" ? "privacy" : "support"),
    [error, setError] = useState(""),
    [reference, setReference] = useState("");
  const submission = useVerifiedSubmission(JSON.stringify({ email, text, topic, accountId }), send);
  async function send(challenge: string) {
    setError("");
    try {
      const r = await api<{ id: string }>("/api/contact", "POST", {
        email: email || undefined, topic, body: text, turnstileToken: challenge,
      });
      setReference(r.id);
    } catch (e) { setError((e as Error).message); }
  }
  return (
    <section className="wrap section narrow">
      <p className="eyebrow">{msg("WE’RE HERE TO HELP")}</p>
      <h1 className="page-title">{msg("A little help.")}</h1>
      {reference ? (
        <div role="status">
          <h2>{msg("Thank you for letting us know.")}</h2>
          <p>{msg("Your message is saved for our team.")}</p>
          <p>{msg("Your reference:")}<code>{reference}</code></p>
          <a className="button" href="/cards?tab=received">{msg("Back to My cards")}</a>
        </div>
      ) : (
        <form onSubmit={e => { e.preventDefault(); submission.request(); }}>
          <p>{msg("For account help, privacy requests, or anything that needs a human. Include an email if you would like a reply.")}</p>
          <label>{msg("Topic")}
            <select disabled={submission.busy} value={topic} onChange={e => setTopic(e.target.value)}>
              {Object.entries({ support: msg("Support and account help"), privacy: msg("Privacy request"), press: msg("Press enquiry"), other: msg("Something else") }).map(([value, label]) => <option key={value} value={value}>{label}</option>)}
            </select>
          </label>
          <label>{msg("Your message")}
            <textarea disabled={submission.busy} required minLength={10} maxLength={4000} rows={6} value={text} onChange={e => setText(e.target.value)} />
          </label>
          <label>{msg("Email")}<small>{msg("optional, for a reply")}</small>
            <input disabled={submission.busy} type="email" autoComplete="email" value={email} onChange={e => setEmail(e.target.value)} />
          </label>
          <p className="form-footnote">{msg("Please don’t include passwords, payment details, or someone else’s private information.")}</p>
          <SubmissionCheck action="contact" submission={submission} />
          {error && <p className="error" role="alert">{error}</p>}
          <button className="button" disabled={submission.busy || !!submission.intent}>
            {submission.busy ? msg("Sending…") : submission.intent ? msg("Verifying…") : msg("Send message")}
          </button>
        </form>
      )}
    </section>
  );
}
